module.exports = __webpack_public_path__ + "assets/img/Type E (12).6cc7e12e.jpg";